import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel, { type InputLabelProps } from '@mui/material/InputLabel';
import FormHelperText, { type FormHelperTextProps } from '@mui/material/FormHelperText';
import InputBase, { type InputBaseProps } from '@mui/material/InputBase';
import clsx from 'clsx';

import { useNumericTextBoxBehavior, type NumericTextBoxType } from './useNumericTextBoxBehavior';

import './TextBox.scss';

type TextBoxType = NumericTextBoxType | React.HTMLInputTypeAttribute;

interface TextBoxProps extends Omit<InputBaseProps, 'type'> {
    type?: TextBoxType,
    label?: React.ReactNode | string,
    InputLabelProps?: InputLabelProps,
    InputProps?: any,
    helperText?: React.ReactNode,
    helperTextId?: string,
    FormHelperTextProps?: FormHelperTextProps
    simpleLabel?: boolean;
}

export const TextBox = React.forwardRef<any, TextBoxProps>((props, ref) => {
    const { label, InputLabelProps, className, disabled, helperText, helperTextId,
        FormHelperTextProps, fullWidth, error, readOnly, style, InputProps, inputProps, simpleLabel = false,
        type, onKeyDown, onPaste, onChange, onBlur, slotProps, ...rest } = props;

    const _readOnly = readOnly ?? inputProps?.readOnly;
    const numeric = useNumericTextBoxBehavior({ type, slotProps, onChange, onKeyDown, onPaste, onBlur });
    const finalLabel = rest.required ? `${label}*` : label;

    return (
        <FormControl ref={ref} disabled={disabled} error={error} fullWidth={fullWidth}
            className={clsx('ms_textbox', _readOnly && 'readonly', simpleLabel && 'simple_label', className)}
            variant="filled" style={style}
        >
            {simpleLabel ? <label className="textbox-label">{finalLabel}</label> : <InputLabel {...InputLabelProps}>{finalLabel}</InputLabel>}
            <InputBase readOnly={readOnly} fullWidth={fullWidth} inputProps={inputProps} type={numeric.htmlType} onKeyDown={numeric.onKeyDown} onPaste={numeric.onPaste} onChange={onChange} onBlur={numeric.onBlur} slotProps={numeric.slotProps} {...InputProps} {...rest}></InputBase>
            {
                helperText && (
                    <FormHelperText id={helperTextId} {...FormHelperTextProps}>
                        {helperText}
                    </FormHelperText>
                )
            }
        </FormControl>
    )
})
